const QRCode = require('qrcode');

export const initQrCode = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const canvas = document.getElementById('qr-code');
        if (canvas) {
            const id = canvas.dataset.id;
            QRCode.toDataURL(`${id}`, function (err, url) {
                canvas.innerHTML = `<img src='${url}'/>`;
            });
        }
    });
}
